chat:
  message:
    character-name:
      airi: Pluto
      core-system: 核心系统
      you: 你
message: 说点什么...
select-a-audio-input: 选择一个音频输入设备
select-a-model: 选择一个模型
select-a-voice: 选择一个声线
viewers:
  debug-menu:
    emotions: 表情
    emotions-btn:
      angry: 😠 生气
      awkward: 😳 尴尬
      happy: 😄 开心
      neutral: 🙂 日常
      question: 🤔 疑问
      sad: 😫 难过
      surprised: 🤯 惊喜
      think: 🤨 思考
    vrm:
      camera: 摄像机
      model:
        title: 模型
waiting: 等待中
operations:
  load-models: 加载模型
  load-models-status:
    loading: 模型加载中
    ready: 已就绪
links:
  get-persona: 获取人设
  get-plugin: 获取插件
